import React, { Fragment } from 'react';
import { Intro, MultipleChoice } from 'abbot-core';
import img from '../../assets/images/U1-T2-4-5.svg';

const data = {
  inputType: 'radio',
  question:
    'Which of the following is NOT a benefit of making nutritious food choices?',
  options: [
    {
      label: 'Increased energy'
    },
    {
      label: 'Less risk of developing certain diseases'
    },
    {
      label: 'Always feeling hungry'
    },
    {
      label: 'Stronger muscles and bones'
    }
  ]
};

const correctInput = {
  [data.question]: data.options[2].label
};

const feedback = {
  success: {
    title: 'Great!',
    body: ''
  },
  error: {
    title: 'Sorry, that’s not quite right.',
    body: ''
  },
  retry: {
    title: 'Not quite, give it another try',
    body: ''
  }
};

export default {
  title: 'Question 5',
  path: '/challenge/question-5',
  content: (
    <Fragment>
      <Intro
        title="Show What You Learned"
        direction="Select the best answer."
        img={img}
      />

      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={1}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/challenge/Question5.js